// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-home {}\n.apps-container {\n    padding: 0 10px 0 30px;\n}\n.grid-content-apps a {\n    color: #9D2449;\n}\n\n", ""]);
// Exports
module.exports = exports;
